module.exports = __webpack_public_path__ + "static/media/underline.da65209d.svg";